<a uiSref="{{sref}}" title="{{text}}" class="button mb-10">
    <i class="fa fa-chevron-left mr-5"></i>{{text}}
</a>
